import { render } from "./TrainingQuiz.vue?vue&type=template&id=a78a01dc&scoped=true&ts=true"
import script from "./TrainingQuiz.vue?vue&type=script&lang=ts"
export * from "./TrainingQuiz.vue?vue&type=script&lang=ts"

import "./TrainingQuiz.vue?vue&type=style&index=0&id=a78a01dc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a78a01dc"]])

export default __exports__